import { useEffect, useState } from "react";
import { ReactComponent as ArticleIcon } from './../assets/icons/article.svg';
import { ReactComponent as PosterIcon } from './../assets/icons/poster.svg';
import styles from "./../style/technology.module.css";
import { useLocation } from "react-router-dom";
import futureOverviewImage from "./../assets/img/theFuture.jpg";


const BusinessDevelopment = () => {


  const [publications, publicationSet] = useState([]);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/publications/publications.json')
      .then(response => response.json())
      .then(data => publicationSet(data));
  }, [])

  const location = useLocation();

  useEffect(() => {
    // Check if there is a hash in the URL
    if (location.hash) {
      const id = location.hash.replace("#", ""); // Remove the '#' from the hash
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // Optionally, scroll to the top if there's no hash
      window.scrollTo(0, 0);
    }
  }, [location]); // Re-run the effect if the location changes

  return (
    <div className={styles.technologyCcontent}>
      {/* MULTIPLEXING */}
      <div id="multiplex" className={styles.technologySectionMultiplex}>
        <div className={`${styles.section} ${styles.multiplexSection}`}>
          <div className={styles.multiplexTextContent}>
            <div className={`${styles.technologySectionTitle} ${styles.technologySectionTitleRevColor}`}>Multiplex engineering platform</div>
            <div className={styles.multiplexText}>
              <li><strong>In Silico precision via Antion Design Studio:</strong><br />
              Our proprietary software leverages advanced algorithms to design and prioritize target sequences with unmatched specificity, ensuring precise silencing levels within isoform and cell-type specificity before any wet-lab work begins.
              </li>
              <li><strong>Modular & versatile design:</strong> Built for flexibility, our approach goes beyond standard single-gene delivery to handle complex genetic modulations.</li>
              <li><strong>Simultaneous co-expression & multiple gene silencing:</strong><br />
               Unlike most technologies, we seamlessly integrate gene addition with programmable silencing within a single construct to unlock simultaneous co-expression and multiple gene silencing.</li>
              <li><strong>Unmatched safety & efficiency:</strong><br />
              By relying on a single gene delivery step rather than multiple rounds of engineering, we achieve unprecedented safety profiles and manufacturing efficiency compared to top-tier competitors.</li>
              <li><strong>Precision tuning (not just On/Off):</strong><br />
              Our technology offers unique "dimmer switch" capabilities, allowing you to tune down gene expression to specific desired levels.</li>
              <li><strong>Optimized therapeutic performance:</strong><br />
              We have demonstrated that functional silencing within a specified range, rather than binary On/Off, often yields superior results for therapeutic cell performance.</li>
            </div>
          </div>
        </div> 
      <div className={styles.theFuture}>
        <img 
          src={futureOverviewImage} 
          alt="Antion's technology overview" 
          className={styles.theFutureImage} 
         />
      </div>
      </div>
      
      <div id="publications" className={styles.technologySectionPublications}>
        <div className={`${styles.section} ${styles.publicationsSection}`}>
          <div className={`${styles.technologySectionTitle} ${styles.technologyTitle}`} style={{ height: 'fit-content' }}>Scientific publications</div>
          <div className={styles.publicationsContent}>
            <ul className={styles.publicationsList}>
              {
                publications.map((item: any, index: number) => (
                  <li className={styles.publicationItem} key={index}>
                    {item.type === "article" && <ArticleIcon className={styles.publicationIcon} />}
                    {item.type === "poster" && <PosterIcon className={styles.publicationIcon} />}
                    <div>
                      <div className={styles.publicationDate}>{item.dateOut}</div>
                      <div className={styles.publicationInfo}>
                        <div className={styles.publicationTitle}><a href={item.link} target="_blank" rel="noopener noreferrer">{item.title}</a></div>
                        <div className={styles.publicationAuthors}>{item.authors.join(", ")}</div>
                      </div>
                    </div>
                  </li>
                ))
              }
            </ul>
          </div>
        </div>
      </div>
    </div >
  )
}

export default BusinessDevelopment